import { Box, Card, Grid, LinearProgress, LinearProgressProps, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { IDashboardCustomerDueDelayItem } from "../../utils/ARDashboard.types";


function LinearProgressWithLabel(props: LinearProgressProps & { value: number, dso?: number }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center'}}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: (props.dso)? 60 : 35 }}>
        <Typography variant="body2" color="text.secondary">
          {(props.dso) ? `${Math.round(props.dso)} dso` :
          `${Math.round(
          props.value,
        )}%`}
        </Typography>
      </Box>
    </Box>
  );
}

const ProgressCards = (props: { title?: string; details?: any }) => {

  return (
    <>
      
        <Card sx={{ minWidth:'100%',mr:'10px'}}>
          <Typography className={'cardHeader'} variant="h4" component="div" sx={{ p: '20px', mb: '10px' }}>
            <Box>{props?.title}</Box>
          </Typography>
          {props?.details && props.details.map((item: IDashboardCustomerDueDelayItem) => {
            return (<>
              <Box sx={{ p: '10px 20px', display: 'flex',mr:'-15px' }} >
                <Box sx={{ flex: '1' }}>{item.customer?.name}</Box>
                <Box sx={{ width: '100%', flex: '1' }}>
                  <LinearProgressWithLabel value={(item.dso)? 0 : item.totalPaid * 100 / item.totalAmount} dso={(item.dso)? Number(item.dso) : 0}/>
                </Box>
              </Box>
            </>)
          })
          }
          {props?.details && props?.details.length==0 && (<Box sx={{ p: '10px 20px', display: 'flex',mr:'-15px' }} ><Box>{"No Data"}</Box></Box>)}
        </Card>
      
    </>
  )

}
export default ProgressCards;